module.exports = __webpack_public_path__ + "static/media/tokens.95ccaa93.svg";